var axios = require("axios");
import Store from "@/store/Store";
import { BaseV2API } from "@/config/Endpoints";

import { EventBus } from "@/utils/EventBus.js";

class API {
    baseUrl = "";

    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }

    getConfig() {
        return {
            headers: {
                Authorization: "Bearer " + Store.state.user.access_token
            }
        };
    }

    refreshToken() {
        return errorHandling(
            axios.get(this.baseUrl + "/refresh", {
                headers: {
                    Authorization: "Bearer " + Store.state.user.refresh_token
                }
            })
        );
    }

    get(endpoint) {
        return errorHandling(axios.get(this.baseUrl + endpoint, this.getConfig()));
    }

    post(endpoint, data) {
        return errorHandling(axios.post(this.baseUrl + endpoint, data, this.getConfig()));
    }

    patch(endpoint, data) {
        return errorHandling(axios.patch(this.baseUrl + endpoint, data, this.getConfig()));
    }
    download(endpoint, data) {
        return errorHandling(
            axios.post(
                this.baseUrl + endpoint,
                data,
                Object.assign(this.getConfig(), { responseType: "blob" })
            )
        );
    }
    upload(endpoint, formData) {
        return errorHandling(
            axios.post(
                this.baseUrl + endpoint,
                formData,
                Object.assign(this.getConfig(), { "Content-Type": "multipart/form-data" })
            )
        );
    }

    put(endpoint, data) {
        return errorHandling(axios.put(this.baseUrl + endpoint, data, this.getConfig()));
    }

    delete(endpoint, data) {
        return errorHandling(
            axios.delete(this.baseUrl + endpoint, { ...this.getConfig(), ...data })
        );
    }
}

function errorHandling(promise) {
    return promise.catch(error => {
        if (error.response && error.response.status) {
            switch (error.response.status) {
                case 401:
                    EventBus.$emit("session-expired");
                    break;
                case 403:
                    EventBus.$emit("send-client-error-info-to-server", {
                        title: "403 Unauthorized",
                        msg: error,
                        code: 403
                    });
                    break;
                case 500:
                    EventBus.$emit("server-unreachable");
                    break;
                default:
                    EventBus.$emit("server-unreachable");
                    break;
            }
        } else {
            // Internet Connection down
            EventBus.$emit("server-unreachable");
        }
        // it's more an Error Interceptor than an Error handler
        throw error;
    });
}

export var UserAPI = new API(BaseV2API);
export var DataV2API = new API(BaseV2API);
